import React from 'react';
import { ModalHeader, ModalBody, ModalFooter, ModalImage } from './components';
import {
  ModalHeaderProps,
  ModalBodyProps,
  ModalFooterProps,
  ModalProps,
} from '@/shared/types/modal';
import { ModalImageProps } from './components/molecules/ModalImage';

/**
 * Crea el componente Modal compuesto con sus sub-componentes
 * Separado del componente base para evitar warnings de react-refresh
 */
export function createModalCompound(ModalComponent: React.FC<ModalProps>) {
  return Object.assign(ModalComponent, {
    Header: ModalHeader,
    Body: ModalBody,
    Footer: ModalFooter,
    Image: ModalImage,
  }) as React.FC<ModalProps> & {
    Header: React.FC<ModalHeaderProps>;
    Body: React.FC<ModalBodyProps>;
    Footer: React.FC<ModalFooterProps>;
    Image: React.FC<ModalImageProps>;
  };
}
